import { render, staticRenderFns } from "./commonLeaveList.vue?vue&type=template&id=6f3e5ab4&scoped=true"
import script from "./commonLeaveList.vue?vue&type=script&lang=js"
export * from "./commonLeaveList.vue?vue&type=script&lang=js"
import style0 from "./commonLeaveList.vue?vue&type=style&index=0&id=6f3e5ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3e5ab4",
  null
  
)

export default component.exports